import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 6);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat?.name || slug;
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <p className="text-sm font-medium text-primary-600 mb-3">最新文章</p>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">精选内容推荐</h2>
          </div>
          <Link
            to="/category/latest"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-200/30 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {getCategoryName(article.category)}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-semibold text-foreground-900 font-heading mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2 flex-1">{article.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {article.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views.toLocaleString()}
                    </span>
                  </div>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime} 分钟
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/latest"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}